<template>
    <v-navigation-drawer stateless value="true">
        <v-toolbar text color="white">
            <v-form @submit="submitForm">
                <v-autocomplete
                    v-model="select"
                    :items="items"
                    :loading="loading"
                    :search-input.sync="search"
                    solo
                    single-line
                    text
                    clearable
                    color="black"
                    hide-no-data
                    hide-selected
                    item-text="phone"
                    item-value="id"
                    placeholder="Поиск по номеру"
                    prepend-icon="search"
                    append-icon=""
                    return-object/>
            </v-form>
        </v-toolbar>
        <v-list v-if="getCustomers.length > 0" class="v-list--booking">
            <v-list-item
                :key="customer.id"
                v-for="customer in getCustomers"
                @click="editCustomer(customer.id)"
                :class="`v-list--booking_state ${$route.params.customerId === customer.id ? 'active' : ''}`">
                <v-list-item-title>{{ customer.phone | formatPhone }}</v-list-item-title>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Customer from '../../../api/customer'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'customerNavigation',
        components: { Empty },
        data: () => ({
            select: null,
            items: [],
            loading: false,
            search: null,
        }),
        methods: {
            editCustomer (id) {
                this.$router.push({
                    name: 'editCustomer',
                    params: { customerId: id }
                })
            },
            searchByPhone (phone) {
                this.loading = true

                Customer
                    .searchByPhone({ phone })
                    .then(response => this.items = response.data.data)
                    .catch(error => {
                        if (error && error.response.headers && error.response.status === 404) {
                            this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        }

                        this.select = null
                    })
                    .finally(() => this.loading = false)
            },
            submitForm (event) {
                event.preventDefault()

                this.searchByPhone(this.search)
            }
        },
        computed: mapGetters([
            'getCustomers'
        ]),
        watch: {
            select (value) {
                if (!value) return

                this.editCustomer(value.id)
            },
            search (value) {
                if (!value || value.length <= 3 || value === this.select) return false
            }
        }
    }
</script>
